import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { ServerIntf, UserScope } from './ServerIntf';
import { useState } from "react";
import './App.css';
import './WinOdometer.css';

const Users = (props) => {
    const [editingRows, setEditingRows] = useState({});

    const onRowEditChange = (e) => {
        setEditingRows(e.data);
    };

    const onRowClick = (event) => {
        const rowData = event.data;
        const newDataKey = rowData.id;

        if (!editingRows[newDataKey]) {
            setEditingRows({ [newDataKey]: { ...rowData } });
        }
    };

    const userEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => {
            const updated = {
                ...(editingRows[options.rowData.id] || options.rowData),
                [options.field]: e.target.value
            };
            setEditingRows((prev) => ({ ...prev, [updated.id]: updated }));
            options.editorCallback(e.target.value);
        }} />;
    };

    const actionTemplate = (rowData) => {
        const current = (rowData && rowData.id && editingRows[rowData.id]) ? editingRows[rowData.id] : rowData;
        return (
            <>
                <Button className="p-button-sm btn-icon" icon="pi pi-check" onClick={() => {
                    if (!current) {
                        ServerIntf.ParseError(new Error('No row data to save'), 1500);
                        return;
                    }
                    ServerIntf.ModifyUser(current);
                    setEditingRows({});
                }} />
                <Button className="p-button-sm btn-icon danger" icon="pi pi-trash" style={{ marginLeft: '0.5rem' }} onClick={() => {
                    if (!current) {
                        ServerIntf.ParseError(new Error('No row data to delete'), 1500);
                        return;
                    }
                    ServerIntf.DeleteUser(current.id);
                }} />
            </>
        );
    };

    const scopeTemplate = (rowData) => {
        const match = Object.entries(UserScope).find(([, val]) => val === rowData.scope);
        return match ? match[0] : rowData.scope;
    };

    const dateTemplate = (value) => {
        if (!value) return '';
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date.toLocaleString();
    };

    if (props.visible) {
        return (
            <div className="inline-table">
                <div className="table-wrapper">
                    <h4 className="table-name">Users</h4>
                    <DataTable value={props.users || []} editMode="row" dataKey="id"
                               editingRows={editingRows} onRowEditChange={onRowEditChange}
                               onRowClick={onRowClick} tableStyle={{minWidth: '60rem'}}>
                        <Column header="Email" field="email" editor={(options) => userEditor(options)}></Column>
                        <Column header="Name" field="username" editor={(options) => userEditor(options)}></Column>
                        <Column header="License" field="license" editor={(options) => userEditor(options)}></Column>
                        <Column header="Permissions" field="scope" body={scopeTemplate} editor={(options) => userEditor(options)}></Column>
                        <Column header="Created At" field="created_at" body={(row) => dateTemplate(row.created_at)}></Column>
                        <Column header="Updated At" field="updated_at" body={(row) => dateTemplate(row.updated_at)}></Column>
                        <Column header="Actions" body={actionTemplate} style={{ minWidth: '8rem' }} />
                    </DataTable>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default Users;
